<template>
    <div class="cic-select">
        <el-select
            v-if="enabled"
            :model-value="value"
            :multiple="multiple"
            :remote-method="remoteMethod"
            v-bind="Object.assign(JSON.parse(JSON.stringify($attrs)), { id: null })"
            filterable
            @update:modelValue="(val) => $emit('input', val)"
        >
            <template v-if="options.some((option) => option.icon && option.value === value)" #prefix>
                <span :class="`cic-select-icon ${options.find((option) => option.value === value).icon}`"></span>
            </template>
            <el-option
                v-for="option in options"
                :key="option.value"
                :label="option.label"
                :value="option.value"
                :disabled="option.disabled"
            >
                <span v-if="option.icon" :class="`cic-select-icon ${option.icon}`"></span>
                <span class="cic-select-label">{{ option.label }}</span>
            </el-option>
        </el-select>
        <span v-else-if="multiple">{{
            options
                .filter((x) => value.indexOf(x.value) >= 0)
                .map((x) => x.label)
                .join(', ')
        }}</span>
        <span v-else>{{
            options.find((x) => x.value === value) ? options.find((x) => x.value === value).label : value
        }}</span>
    </div>
</template>

<script>
    import { ElSelect, ElOption } from 'element-plus';

    export default {
        name: 'CicSelect',
        components: {
            'el-select': ElSelect,
            'el-option': ElOption,
        },
        props: {
            value: {
                type: [Number, String, Array],
                default: null,
            },

            options: {
                type: Array,
                required: true,
            },

            defaultWhenSingleOption: {
                type: Boolean,
                default: false,
            },

            enabled: {
                type: Boolean,
                default: true,
            },

            multiple: {
                type: Boolean,
                default: false,
            },

            remoteMethod: {
                type: Function,
                default: undefined,
            },
        },
        emits: ['input'],
        created() {
            this.setDefaultValue();
        },
        methods: {
            setDefaultValue() {
                if (this.options.length === 1 && this.defaultWhenSingleOption) {
                    let optionValue = this.options[0].value;
                    if (this.value !== optionValue) {
                        this.$emit('input', optionValue);
                    }
                }
            },
        },
    };
</script>
